import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  orderBy,
  query
} from 'firebase/firestore';
import { db } from "../../firebase/firebaseConfig";

const EditSlideShow = () => {
  const [searchParams] = useSearchParams();
  const slideId = searchParams.get("slideId");
  const slideshowId = searchParams.get("slideshowId");
  const [slides, setSlides] = useState([]);
  const [slideData, setSlideData] = useState(null);
  const [caption, setCaption] = useState("");
  const [order, setOrder] = useState(0);

  useEffect(() => {
    const fetchSlides = async () => {
      const q = query(collection(db, `slideshows/${slideshowId}/slides`), orderBy('order'));
      const snapshot = await getDocs(q);
      setSlides(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchSlides();
  }, [slideshowId]);

  useEffect(() => {
    const fetchSlide = async () => {
      if (slideId && slideshowId) {
        const slideRef = doc(db, `slideshows/${slideshowId}/slides`, slideId);
        const slideSnap = await getDoc(slideRef);
        if (slideSnap.exists()) {
          const data = slideSnap.data();
          setSlideData(data);
          setCaption(data.caption || "");
          setOrder(data.order || 0);
        }
      }
    };
    fetchSlide();
  }, [slideId, slideshowId]);

  const handleUpdate = async (slide) => {
    const slideRef = doc(db, `slideshows/${slideshowId}/slides`, slide.id);
    await updateDoc(slideRef, {
      caption: slide.caption,
      beatText: slide.beatText
    });
    alert('Slide updated');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this slide?')) return;
    await deleteDoc(doc(db, `slideshows/${slideshowId}/slides`, id));
    setSlides(slides.filter(s => s.id !== id));
  };

  const handleSave = async () => {
    if (slideId && slideshowId) {
      const slideRef = doc(db, `slideshows/${slideshowId}/slides`, slideId);
      await updateDoc(slideRef, { caption, order });
      alert("Slide updated successfully!");
    }
  };

  if (!slideData) {
    return <p>Loading slide data...</p>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>Edit Slideshow: {slideshowId}</h2>
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          style={{
            border: '1px solid #ccc',
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '8px'
          }}
        >
          <img src={slide.imageUrl} alt={`Slide ${i + 1}`} style={{ maxWidth: '100%', maxHeight: 200 }} />
          <input
            type="text"
            value={slide.caption}
            onChange={(e) => {
              const newSlides = [...slides];
              newSlides[i].caption = e.target.value;
              setSlides(newSlides);
            }}
            placeholder="Caption"
            style={{ width: '100%', margin: '5px 0' }}
          />
          <textarea
            value={slide.beatText}
            onChange={(e) => {
              const newSlides = [...slides];
              newSlides[i].beatText = e.target.value;
              setSlides(newSlides);
            }}
            placeholder="Beat-synced text"
            style={{ width: '100%', marginBottom: '5px' }}
          />
          <button onClick={() => handleUpdate(slide)}>Update</button>
          <button onClick={() => handleDelete(slide.id)} style={{ marginLeft: '10px', backgroundColor: '#f44336', color: 'white' }}>
            Delete
          </button>
        </div>
      ))}
      <div style={{ marginTop: "20px" }}>
        <label>
          Caption:
          <input
            type="text"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            style={{ marginLeft: "10px", padding: "5px", width: "100%" }}
          />
        </label>
      </div>
      <div style={{ marginTop: "20px" }}>
        <label>
          Order:
          <input
            type="number"
            value={order}
            onChange={(e) => setOrder(parseInt(e.target.value, 10))}
            style={{ marginLeft: "10px", padding: "5px", width: "100px" }}
          />
        </label>
      </div>
      <button onClick={handleSave} style={{ marginTop: "20px", padding: "10px 20px" }}>
        Save Changes
      </button>
    </div>
  );
};

export default EditSlideShow;
